import { isWhiteLabel, getSubdomain } from "utils/whiteLabel";

// A partner subdomain counts as a main-site host: Core is dashboard-only, and
// only the is_main branch in ReactRouteAll mounts /default/*, which is where
// the Academic → Core SSO handoff (/default/check/post?cust=…) lands.
export const resolveIsMain = () =>
  window.location.hostname.split(".").shift() === "www" ||
  (isWhiteLabel() && getSubdomain() !== null);

const reducer = (
  state = {
    token: null,
    notifications: [],
    user: null,
    loaded: true,
    subscribed: false,
    is_main: resolveIsMain(),
    is_portal:
      window.location.href.search("pteportal.com") !== -1 ? true : false,
    logo: "",
    expVidPopup: 0,
    alert: { flag: false, type: 1, message: "testing" },
    userType: null,
    passwordPopup: false,
     regionAccess: true,
    user_region: "your region",
    // White-label: partner palette and module toggles. Both null on an LA
    // build. The institute id is NOT duplicated here — it already arrives on
    // state.user.institute via setUser() in CheckPost/Login.
    theme: null,
    features: null,
  },
  action
) => {
  switch (action.type) {
    case "SETTOKEN":
      return { ...state, token: action.val };
    case "SETLOADER":
      return { ...state, loaded: action.val };
    case "SETUSER":
      return { ...state, user: action.val };
    case "SETSUB":
      return { ...state, subscribed: action.val };
    case "SETALERT":
      return { ...state, alert: action.val };
    case "SETLOGO":
      return { ...state, logo: action.val };
    case "SETISMAIN":
      return { ...state, is_main: action.val };
    case "ISPORTAL":
      return { ...state, is_portal: action.val };
    case "ISMODALSHOWN":
      return { ...state, isModalShown: action.val };
    case "INTSTATUS":
      return { ...state, intStatus: action.val };
    case "EXPVIDPOPUP":
      return { ...state, expVidPopup: action.val };
    case "USERTYPE":
      return { ...state, userType: action.val };
    case "NOTIFICATIONS":
      return { ...state, notifications: action.val };
    case "PASSWORDPOPUP":
      return { ...state, passwordPopup: action.val };
    case "SETREGIONACCESS":
      return { ...state, regionAccess: action.val };
    case "SETTHEME":
      return { ...state, theme: action.val };
    case "SETFEATURES":
      return { ...state, features: action.val };
    case "RESET_AUTH":
      return { ...state, token: null, user: null, subscribed: false, expVidPopup: 0, passwordPopup: false, regionAccess: true };
    default:
      return state;
  }
};
export default reducer;
